import component from './component'
import { connect } from 'react-redux'
import {
  MODAL,
  HOLIDAY,
  ROOM,
} from '../../../reduxs'
import { bindActionCreators } from 'redux'

function mapStateToProps (state, ownProps) {
  return {
    accountReducer: state.accountReducer,
    settingReducer: state.settingReducer,
    roomReducer: state.roomReducer,
    language: state.accountReducer.language,
    username: state.accountReducer.user.username,
    modalStatus: state.modalReducer.status,
    modalReducer: state.modalReducer,
    permission: state.accountReducer.permission,
    holidayReducer: state.holidayReducer,
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModalStatus: (div) => dispatch(MODAL.action.openModalStatus(div)),
    closeModalStatus: () => dispatch(MODAL.action.closeModalStatus()),
    openModalConfirm: (div) => dispatch(MODAL.action.openModalConfirm(div)),
    closeModalConfirm: () => dispatch(MODAL.action.closeModalConfirm()),
    getListHoliday: (param) => dispatch(HOLIDAY.action.getListHoliday(param)),
    modalAction: bindActionCreators(MODAL.action, dispatch),
    roomAction: bindActionCreators(ROOM.action, dispatch),
  }
}

export default connect(
  (state, ownProps) => mapStateToProps(state, ownProps),
  (dispatch) => mapDispatchToProps(dispatch)
)(component)
